<template lang="pug">
    div
        h1.h1(v-if="type === 'h1'" v-html="title")
        h1.h2(v-if="type === 'h2'" v-html="title")
        h3.h1(v-if="type === 'h3'" v-html="title")
        h4.h4(v-if="type === 'h4'" v-html="title")
        h5.h5(v-if="type === 'h5'" v-html="title")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            title: VueTypes.string.def(''),
            type: VueTypes.string.def('h1')
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .h1
        padding-bottom: 0
        margin-bottom: 1rem
        font-size: remify(40px)
        color: $theme.white
        font-weight: 300

    .noMargin .h1
    .noMargin .h2
        margin-bottom: 0 !important

    .h2
        @extend .h1
        color: $theme.white

    .h4
        @extend .h1
        color: $theme.white
        font-size: remify(24px)

    .h5
        @extend .h4
        color: $theme.white

    @media screen and (max-width: $grid-breakpoints.lg - 1)
        .h1
            font-size: 28px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        h1.h1
        .h2
            font-size: remify(20px)
            margin-bottom: 8px
        h4.h4
        h5.h5
            font-size: remify(18px)
            margin-bottom: 6px
        h3.h1
            font-size: remify(15px)
            line-height: 22px
            margin-bottom: 4px
</style>
